import React from "react";

import { getHeaderTranslationId } from "../../helpers";
import { useIntlTranslate } from "../../../../hooks";
import { useSortValues } from "../../hooks";

enum SortingOrderKeys {
  NoSort = "sort_default",
  Ascending = "sort_asc",
  Descending = "sort_desc",
}

const getSortingOrderKey: ({
  isSorted,
  isSortedDesc,
}: {
  isSorted: boolean;
  isSortedDesc: boolean;
}) => string = (sort): string => {
  if (!sort) return SortingOrderKeys.NoSort;

  return sort.isSorted
    ? sort.isSortedDesc
      ? SortingOrderKeys.Descending
      : SortingOrderKeys.Ascending
    : SortingOrderKeys.NoSort;
};

export const TableSortStatus = ({ tableName, headerGroups }) => {
  const translate = useIntlTranslate();
  const { sortedBy } = useSortValues(headerGroups);

  if (!sortedBy) {
    return (
      <span className="sr-only" role="status">
        {translate("aria_table_not_sorted_by", { tableName: tableName })}
      </span>
    );
  }

  const sortingOrder = translate(getSortingOrderKey(sortedBy));
  const status = translate("aria_table_sorted_by", {
    tableName: tableName,
    sortedBy: translate(getHeaderTranslationId(headerGroups, sortedBy.id)),
    sortingOrder,
  });

  return (
    <span className="sr-only" role="status">
      {status}
    </span>
  );
};
